export default "__VITE_ASSET__C6EVj3Bm__"